import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

import { getChannelIcon, getChannelLabel } from '../../utils';

@Component({
  selector: 'app-channel-icon',
  standalone: true,
  imports: [NgClass],
  template: `
    <span
      class="ch-icon"
      [style.width]="size"
      [style.height]="size"
      [style.font-size]="size"
      [attr.data-channel]="channel"
      [attr.title]="label"
    >
      <i [ngClass]="iconClass"></i>
    </span>
  `,
  styleUrl: './channel-icon.component.scss',
})
export class ChannelIconComponent {
  @Input() channel: string = '';
  @Input() size: string = '2rem';

  get iconClass(): string {
    return getChannelIcon(this.channel);
  }

  get label(): string {
    return getChannelLabel(this.channel);
  }
}
